import Footer from "@Components/Layout/Footer";
import Register from "@Components/Pages/Register";

const RegistrationPage = () => {
  return (
    <>
      <Register />
      <Footer />
    </>
  );
};
export default RegistrationPage;
RegistrationPage.displayName = "registration";
